import { instance } from "config/axiosInstance";

const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getHistory(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}
